<template>
  <header class="my-page-header">
    <div class="my-page-header__bg-image"></div>
    <div class="my-page-header__container">
      <div class="my-page-header__container-inner">
        <h1 class="my-page-header__headline">{{ $t('myPage.title') }}</h1>
        <nav class="tabs">
          <button
            @click="setActiveTab('profile')"
            class="tabs-button"
            :class="{ 'tabs-button--active': activeTab === 'profile' }"
          >
            {{ $t('myPage.profile.title') }}
          </button>
          <button
            @click="setActiveTab('bookings')"
            class="tabs-button"
            :class="{ 'tabs-button--active': activeTab === 'bookings' }"
          >
            {{ $t('myPage.bookings.title') }}
          </button>
        </nav>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useI18n } from 'vue-i18n'

  export default defineComponent({
    name: 'MyPageHeader',
    props: {
      activeTab: {
        type: String,
        required: true,
      },
    },
    emits: ['update:activeTab'],
    setup(props, { emit }) {
      const { t } = useI18n()

      const setActiveTab = (tab: string) => {
        emit('update:activeTab', tab)
      }

      return {
        setActiveTab,
        t,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .my-page-header {
    position: sticky;
    z-index: 10;
    margin-right: -16px;
    margin-left: -16px;
    margin-bottom: 20px;
    top: 68px;
    padding-right: 16px;
    padding-left: 16px;
    color: $clr-primary-800;
    background-color: $clr-white;
    box-shadow: $box-shadow-card;

    &__bg-image {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 0;
      width: 322px;
      height: 78px;
      background: transparent url(@/assets/icons/landscape.svg) bottom left
        no-repeat;
      transform: scaleX(-1);
      opacity: 0.2;
    }

    &__container {
      position: relative;
      z-index: 1;
      padding-top: rem(12);
      max-width: $main-width;
      margin: 0 auto;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 12px;

      &-inner {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 12px;

        @media screen and (min-width: $breakpoint-xs) {
          gap: 18px;
        }
      }
    }

    &__headline {
      @include headline-medium;
      margin-top: 0;
      margin-bottom: 0;
      text-align: left;
    }
  }
</style>
